export const formatItalianNumber = (value, {
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
} = {}) => {
  const number = Number(value || 0);
  const safeNumber = Number.isFinite(number) ? number : 0;
  const [integerPart, fractionPart = ""] = safeNumber.toFixed(maximumFractionDigits).split(".");
  const integer = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const fraction = fractionPart.replace(/0+$/, "").padEnd(minimumFractionDigits, "0");
  return fraction ? `${integer},${fraction}` : integer;
};
